// The document types the QMS library holds, with their labels. The server
// (src/lib/qmsVersions.js) imports the list from here, the way it does the RBAC
// defaults and the HTML allowlist, so a type the pages can group and label is
// exactly a type the API will store. Announcements come first because they are
// the time-bound ones: a notice everyone must read this week should not sit
// below the procedures. Quality Docs groups documents in this order; QMS
// Control offers them in this order when creating or editing.
export const QMS_DOC_TYPES = ['announcement', 'policy', 'procedure', 'process', 'work_instruction', 'form', 'guidance'];

export const QMS_DOC_TYPE_LABELS = {
  announcement:     { label: 'Announcement',     plural: 'Announcements' },
  policy:           { label: 'Policy',           plural: 'Policies' },
  procedure:        { label: 'Procedure',        plural: 'Procedures' },
  process:          { label: 'Process',          plural: 'Processes' },
  work_instruction: { label: 'Work Instruction', plural: 'Work Instructions' },
  form:             { label: 'Form',             plural: 'Forms' },
  guidance:         { label: 'Guidance',         plural: 'Guidance' },
};

/** Ordered `{ value, label }` pairs for a select. */
export const QMS_DOC_TYPE_OPTIONS = QMS_DOC_TYPES.map(value => ({ value, label: QMS_DOC_TYPE_LABELS[value].label }));

export function docTypeLabel(value) {
  return QMS_DOC_TYPE_LABELS[value]?.label || value;
}

export function docTypePlural(value) {
  return QMS_DOC_TYPE_LABELS[value]?.plural || value;
}
